import { useRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { CanvasRefProps } from './types'

export type SignatureCanvasProps = SignatureCanvas & CanvasRefProps

export const useSignatureCanvasRef = () => useRef<SignatureCanvasProps>(null)
